import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
import { FetchResultType } from "../fetchTypes";
export const getAllPackage = createAsyncThunk(
  "/package/get",
  async (params:any, { rejectWithValue }) => {
    try {
 
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/package/GetPackage",params);
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e:any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export type AllPackage ={
  package:{
    data:Array<{
      endDate:Date
    }>
  } 
}
export interface AllPackageStateType extends FetchResultType {
  package:{
    data:Array<{
      endDate:Date
    }>
  } 
}

export const packageSlice = createSlice({
  name: "packageSlice",
  initialState: {
    package: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.package = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPackage.fulfilled, (state, { payload }) => {
      state.package = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getAllPackage.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
    });
    builder.addCase(getAllPackage.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = packageSlice.actions;

export const packageSelector = (state:any) => state.package;

export const packageReducer = packageSlice.reducer;
